import { IConflictCheckParams } from '../../interface/conflictCheck';

export const isConflictCheckFormChanged = (
  conflictCheckParams: IConflictCheckParams | null | undefined,
): boolean => {
  return !!conflictCheckParams?.subject || !!conflictCheckParams?.description;
};
